import {AfterViewChecked, ChangeDetectorRef, Component, computed, OnInit, signal, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {Subject, Subscription, forkJoin, Observable} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {MatStep} from '@angular/material/stepper';
import {debounceTime, distinctUntilChanged, finalize, take, takeUntil, tap} from 'rxjs/operators';
import {DatePipe} from '@angular/common';
import {HelpDTO} from 'src/app/modules/other/models/HelpDTO';
import {ReturnMessageDTO} from 'src/app/modules/clm/models/ReturnMessageDTO';
import {InsuredPersonService} from '../../../services/insured-person.service';
import {HelpService} from 'src/app/modules/other/services/help.service';
import {ErrorDialogComponent} from 'src/app/modules/common/dialogs/error-dialog/error-dialog.component';
import {LookupService} from 'src/app/modules/common/services/lookup.service';
import {AddressDTO} from '../../../models/AddressDTO';
import {KeycloakService} from 'keycloak-angular';
import {ContactDTO} from 'src/app/modules/ent/models/ContactDTO';
import {PagedRequestDTO} from 'src/app/modules/common/models/PagedRequestDTO';
import {Common, createFieldMap} from 'src/app/modules/common/util/Util';
import {DateUtil} from 'src/app/modules/common/util/DateUtil';
import {InsuredPersonDTO} from 'src/app/modules/ent/models/InsuredPersonDTO';
import {CoverStatusDTO} from 'src/app/modules/ent/models/CoverStatusDTO';
import {MatButton} from '@angular/material/button';
import {NameValueDTO} from 'src/app/modules/common/models/NameValueDTO';
import {CoverStatusLinkDTO} from 'src/app/modules/ent/models/CoverStatusLinkDTO';
import {DisplayStrings} from 'src/app/modules/common/constants/DisplayStrings';
import {Role} from '../../../../clm/types/role.enum';
import {EntityTable} from '../../../../common/types/entity-table.enum';
import {LookupValue} from '../../../../clm/types/lookup-value.enum';
import {ClmRequestBuilder} from '../../../../clm/services/clm-request-builder';
import {PagedResponseDTO} from '../../../../common/models/PagedResponseDTO';
import {PolicyDTO} from '../../../models/PolicyDTO';
import {SharedService} from '../../../../common/services/shared-service';
import {PolicyService} from '../../../services/policy.service';
import {ProductDTO} from '../../../models/ProductDTO';
import {ProductService} from '../../../services/product.service';
import {PersonPolicyProductLinkDTO} from '../../../models/person/PersonPolicyProductLinkDTO';
import {CreateNameValueCodeDTO, NameValueCodeDTO} from '../../../../common/models/NameValueCodeDTO';
import {InsuredPersonExclusionDTO} from '../../../models/InsuredPersonExclusionDTO';
import {CoverageHistoryDTO} from '../../../models/person/CoverageHistoryDTO';
import {RemunerationDTO} from '../../../models/person/RemunerationDTO';
import {DiagnosisGroupDTO} from '../../../models/diagnosis/DiagnosisGroupDTO';
import {CustomValidator} from 'src/app/modules/common';
import {AddressFormComponent} from '../../../../common/components/common-steps/address-form/address-form.component';
import {
  ContactFormComponent,
  ContactFormInputs
} from '../../../../common/components/common-steps/contact-form/contact-form.component';
import {EnterpriseRoutesQueryParam} from '../../../../common/types/routes-query-param.enum';
import {PortalType} from '../../../../common/types/portal.enum';
import {BankAccountLinkDTO} from '../../../models/BankAccountLinkDTO';
import {AddBankAccountDialogComponent} from '../../dialogs/add-bank-account-dialog/add-bank-account-dialog.component';


export function minimumCoveredStatus(coveredStatus: any[]): ValidatorFn {
  return (): { [key: string]: any } | null => {
    return coveredStatus && coveredStatus.length > 0 ? null : {minimumCoveredStatus: true};
  };
}

export function minimumPreExistingCondition(preExistingCondition: any[]): ValidatorFn {
  return (): { [key: string]: any } | null => {
    return preExistingCondition && preExistingCondition.length > 0 ? null : {minimumPreExistingCondition: true};
  };
}

const PAGE_SIZE = 20;

@Component({
  selector: 'app-add-insured-person-view',
  templateUrl: './add-insured-person-view.component.html',
  styleUrls: ['./add-insured-person-view.component.scss', '../../../../../../styles/global/_add-view-edit-styles.scss']
})


export class AddInsuredPersonViewComponent implements OnInit, AfterViewChecked {
  readonly debounceTime = Common.DEBOUNCE_TIME;
  readonly destroyed$ = new Subject();
  readonly lookupValue = LookupValue;
  readonly policyNumberTextChanged$ = new Subject<string>();
  readonly PortalType = PortalType;

  listFormRowHeight = '60px';
  isRequired = false;
  dateFormatString = DateUtil.dateFormat;
  returnMessage: ReturnMessageDTO;
  heading: string;
  tabName: string;
  updateStatus: string;
  addToMembership: string;
  previousMedicalAid: string;
  remunerationHistory: string;
  backPageName: string;
  associatedPerson: string;
  middleNameFormControl: FormControl;
  insuredPerson: InsuredPersonDTO;
  titleFormControl: FormControl;
  firstNameFormControl: FormControl;
  associatedPersonFormControl: FormControl;
  maritalStatusFormControl: FormControl;
  passportNumberFormControl: FormControl;
  genderFormControl: FormControl;
  nationalIdNumberFormControl: FormControl;
  lastNameFormControl: FormControl;
  associationFormControl: FormControl;
  alternativeCardNumberFormControl: FormControl;
  nationalityFormControl: FormControl;
  dateOfBirthFormControl: FormControl;
  dateOfMarriageFormControl: FormControl;
  ethnicityFormControl: FormControl;
  languageFormControl: FormControl;


  generalFormGroup: FormGroup;
  statusFormGroup: FormGroup;
  medicalHistoryFormGroup: FormGroup;
  financialFormGroup: FormGroup;
  statusStartDateFormControl: FormControl;
  statusFormControl: FormControl;
  policyFormControl: FormControl;
  productFormControl: FormControl;
  addressType: FormControl;
  countryFormControl: FormControl;
  provinceFormControl: FormControl;
  cityTownFormControl: FormControl;
  addressLineOneFormControl: FormControl;
  addressLine2FormControl: FormControl;
  postalCodeFormControl: FormControl;
  doNotOverwriteAddress: FormControl;
  contactDesignationFormControl: FormControl;
  contactTitleFormControl: FormControl;
  contactFirstNameFormControl: FormControl;
  contactMiddleNameFormControl: FormControl;
  contactLastNameFormControl: FormControl;
  contactEmailFormControl: FormControl;
  contactMobileFormControl: FormControl;
  contactLandlineFormControl: FormControl;
  doNotOverwriteContact: FormControl;
  conditionFormControl: FormControl;
  conditionStartDateFormControl: FormControl;
  conditionEndDateFormControl: FormControl;
  schemeFormControl: FormControl;
  coverageAssociationFormControl: FormControl;
  coverageMembershipNumberFormControl: FormControl;
  coverageStartDateFormControl: FormControl;
  coverageEndDateFormControl: FormControl;
  remunerationAmountFormControl: FormControl;
  remunerationPeriodFormControl: FormControl;
  remunerationStartDateFormControl: FormControl;
  remunerationEndDateFormControl: FormControl;
  taxNumberFormControl: FormControl;
  idNumberExistsFormControl: FormControl;
  associatedPersonTextChanged = new Subject<string>();
  associatedPersonSubscription: Subscription;
  associatedPersonData: InsuredPersonDTO[];
  selectedAssociatedPerson: NameValueDTO;
  isEdit = false;
  digitalCopyBase64 = null;
  idCopyBase64 = null;
  associations = [];
  regulator = [];
  entityStatus = [];
  coverStatuses = [];
  addressTypes = [];
  countries = [];
  designations = [];
  titles: NameValueDTO[] = [];
  maritalStatus = [];
  genders = [];
  languages = [];
  ethnicities: NameValueCodeDTO[] = [];
  schemes = [];
  diagnosisGroups = [];
  periods = [];
  address: AddressDTO;
  contact: ContactDTO;
  idErrorMessagesList;
  addressErrorMessagesList;
  contactErrorMessages;
  statusErrorMessagesList;
  minStatusError: string;
  statusRequiredFieldsSelected = true;
  selectedCoverStatuses: CoverStatusLinkDTO[] = [];
  idErrorMessage: string = null;
  addressErrorMessage: string = null;
  statusErrorMessage: string = null;
  userFirstLastName = null;
  contactMessage: string;
  insuredPersonId = null;
  helpInfo: HelpDTO[];
  minDate: Date;
  userRoles: string[];
  filteredPolicies: PolicyDTO[];
  selectedPolicy: PolicyDTO;
  products: ProductDTO[];
  selectedProduct: ProductDTO;
  selectedConditionExclusions: InsuredPersonExclusionDTO[];
  preExistingConditionError = false;

  bankAccounts = signal<BankAccountLinkDTO[]>([]);
  bankAccountButtonLabel = computed(() => this.bankAccounts().length > 0 ? 'Edit Account' : 'Add Account');

  // Handling Specific Updates General Step -> Contact Form
  contactFormInputs: ContactFormInputs = {};
  currentPortal: PortalType;
  customRoute: string;

  @ViewChild('generalStep', {static: false}) private generalStep: MatStep;
  @ViewChild('addressStep', {static: false}) private addressStep: MatStep;
  @ViewChild('contactsStep', {static: false}) private contactsStep: MatStep;
  @ViewChild('statutoryStep', {static: false}) private statutoryStep: MatStep;
  @ViewChild('statusStep', {static: false}) private statusStep: MatStep;
  @ViewChild('activityBackButton', {static: false}) private activityBackButton: MatButton;
  @ViewChild('activityClearButton', {static: false}) private activityClearButton: MatButton;
  @ViewChild('finishButton', {static: false}) private finishButton: MatButton;
  @ViewChild('addressForm', {static: false}) private addressForm: AddressFormComponent;
  @ViewChild('contactForm', {static: false}) private contactForm: ContactFormComponent;
  @ViewChild('addressFormComponent') addressFormComponent: AddressFormComponent;
  @ViewChild('contactFormComponent') contactFormComponent: ContactFormComponent;

  private readonly ID_NUMBER_VALIDATORS = [
    Validators.required,
    CustomValidator.idNumberNumeric,
    CustomValidator.idNumberLength,
    CustomValidator.idNumberDOB,
    CustomValidator.idLuhnValidation
  ];

  private backendProvidedId: string | null = null;


  constructor(
    private changeDetect: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private helpService: HelpService,
    private router: Router,
    public datePipe: DatePipe,
    private insuredPersonService: InsuredPersonService,
    private lookupService: LookupService,
    private keycloakService: KeycloakService,
    private sharedService: SharedService,
    private policyService: PolicyService,
    private productService: ProductService
  ) {
    this.route.params.subscribe(params => {
      this.insuredPersonId = params.id;
    });
    const today = new Date();
    const firstDateOfNextMonth = new Date(Date.UTC(today.getFullYear(), today.getMonth(), 1));
    this.minDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    this.tabName = EnterpriseRoutesQueryParam.Person;
    this.backPageName = 'enterprise-management';

    const parentData = this.route.parent?.snapshot.data;
    this.currentPortal = parentData?.portalType || PortalType.Normal;
    this.customRoute = this.getCustomRoute();

    this.selectedConditionExclusions = [];
    this.helpInfo = [];
    this.associatedPerson = 'No';
    this.isRequired = false;
    this.updateStatus = 'No';
    this.addToMembership = 'No';
    this.previousMedicalAid = 'No';
    this.remunerationHistory = 'No';
    this.digitalCopyBase64 = null;
    this.idErrorMessagesList = DisplayStrings.idErrorMessagesList;
    this.addressErrorMessagesList = DisplayStrings.addressErrorMessagesList;
    this.contactErrorMessages = DisplayStrings.contactErrorMessages;
    this.statusErrorMessagesList = DisplayStrings.statusErrorMessagesList;
    this.minStatusError = this.statusErrorMessagesList.minStatusError;
    this.idErrorMessage = this.idErrorMessagesList.idNumberLength;
    this.addressErrorMessage = this.addressErrorMessagesList.minAddressError;
    this.contactMessage = this.contactErrorMessages.minContactError;
    this.associatedPersonData = [];
    this.middleNameFormControl = new FormControl();
    this.titleFormControl = new FormControl();
    this.firstNameFormControl = new FormControl();
    this.associatedPersonFormControl = new FormControl();
    this.maritalStatusFormControl = new FormControl();
    this.passportNumberFormControl = new FormControl();
    this.genderFormControl = new FormControl();
    this.nationalIdNumberFormControl = new FormControl('', this.ID_NUMBER_VALIDATORS);
    this.lastNameFormControl = new FormControl();
    this.associationFormControl = new FormControl();
    this.alternativeCardNumberFormControl = new FormControl();
    this.nationalityFormControl = new FormControl();
    this.dateOfBirthFormControl = new FormControl();
    this.dateOfMarriageFormControl = new FormControl();
    this.languageFormControl = new FormControl();
    this.ethnicityFormControl = new FormControl();
    this.contactDesignationFormControl = new FormControl();
    this.contactTitleFormControl = new FormControl();
    this.contactFirstNameFormControl = new FormControl();
    this.contactMiddleNameFormControl = new FormControl();
    this.contactLastNameFormControl = new FormControl();
    this.contactEmailFormControl = new FormControl();
    this.contactMobileFormControl = new FormControl();
    this.contactLandlineFormControl = new FormControl();
    this.doNotOverwriteContact = new FormControl();
    this.countryFormControl = new FormControl();
    this.provinceFormControl = new FormControl();
    this.cityTownFormControl = new FormControl();
    this.addressLineOneFormControl = new FormControl();
    this.addressLine2FormControl = new FormControl();
    this.postalCodeFormControl = new FormControl();
    this.doNotOverwriteAddress = new FormControl();
    this.addressType = new FormControl();
    this.statusFormControl = new FormControl();
    this.policyFormControl = new FormControl();
    this.productFormControl = new FormControl();
    this.statusStartDateFormControl = new FormControl(firstDateOfNextMonth);
    this.conditionFormControl = new FormControl();
    this.conditionStartDateFormControl = new FormControl();
    this.conditionEndDateFormControl = new FormControl();
    this.schemeFormControl = new FormControl();
    this.coverageAssociationFormControl = new FormControl();
    this.coverageMembershipNumberFormControl = new FormControl();
    this.coverageStartDateFormControl = new FormControl();
    this.coverageEndDateFormControl = new FormControl();
    this.remunerationAmountFormControl = new FormControl();
    this.remunerationPeriodFormControl = new FormControl();
    this.remunerationStartDateFormControl = new FormControl();
    this.remunerationEndDateFormControl = new FormControl();
    this.taxNumberFormControl = new FormControl();

    this.generalFormGroup = this.formBuilder.group({
      middleName: this.middleNameFormControl,
      title: this.titleFormControl,
      firstName: this.firstNameFormControl,
      associatedPerson: this.associatedPersonFormControl,
      maritalStatus: this.maritalStatusFormControl,
      passportNumber: this.passportNumberFormControl,
      gender: this.genderFormControl,
      nationalIdNumber: this.nationalIdNumberFormControl,
      lastName: this.lastNameFormControl,
      association: this.associationFormControl,
      nationality: this.nationalityFormControl,
      dateOfBirth: this.dateOfBirthFormControl,
      dateOfMarriage: this.dateOfMarriageFormControl,
      language: this.languageFormControl,
      ethnicity: this.ethnicityFormControl,
      idNumberExists: this.idNumberExistsFormControl,
    });
    this.statusFormGroup = this.formBuilder.group({
        alternativeCardNumber: this.alternativeCardNumberFormControl,
        statusStartDate: this.statusStartDateFormControl,
        policy: this.policyFormControl,
        product: this.productFormControl
      }
    );
    this.medicalHistoryFormGroup = this.formBuilder.group({
      condition: this.conditionFormControl,
      conditionStartDate: this.conditionStartDateFormControl,
      conditionEndDate: this.conditionEndDateFormControl,
      scheme: this.schemeFormControl,
      association: this.coverageAssociationFormControl,
      membershipNumber: this.coverageMembershipNumberFormControl,
      coverageStartDate: this.coverageStartDateFormControl,
      coverageEndDate: this.coverageEndDateFormControl
    });
    this.financialFormGroup = this.formBuilder.group({
        amount: this.remunerationAmountFormControl,
        period: this.remunerationPeriodFormControl,
        remunerationStartDate: this.remunerationStartDateFormControl,
        remunerationEndDate: this.remunerationEndDateFormControl,
        taxNumber: this.taxNumberFormControl
      }
    );

    this.associatedPersonSubscription = this.associatedPersonTextChanged.pipe(
      debounceTime(this.debounceTime)
    ).subscribe(() => {
      this.getFilteredListOfAssociatedPerson();
    });

    this.idNumberExistsFormControl = new FormControl(true);
  }

  ngOnInit(): void {
    this.getHelpInfo('Insured Person');
    this.userRoles = this.keycloakService.getUserRoles();
    this.keycloakService.loadUserProfile().then((profile) => {
      this.userFirstLastName = `${profile.firstName} ${profile.lastName}`;
    });

    this.initializeLookupData()
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe({
        next: () => {
          if (this.router.url.includes('edit-person')) {
            this.getInsuredPersonById(this.insuredPersonId);
            this.isEdit = true;
            this.heading = 'Edit Person';
          }
          else if (this.router.url.includes('add-person')) {
            this.heading = 'Add Person';
          }
        }
      });

    this.initSubscriptions();
  }

  private initializeLookupData(): Observable<any[]> {
    const lookupRequests = [
      this.getListOfLookupValues(this.lookupValue.Language),
      this.getListOfLookupValues(this.lookupValue.Ethnicity),
      this.getListOfLookupValues(this.lookupValue.Payer),
      this.getListOfLookupValues(this.lookupValue.Association),
      this.getListOfLookupValues(this.lookupValue.Regulator),
      this.getListOfLookupValues(this.lookupValue.EntityStatus),
      this.getListOfLookupValues(this.lookupValue.AddressType),
      this.getListOfLookupValues(this.lookupValue.Designation),
      this.getListOfLookupValues(this.lookupValue.Country),
      this.getListOfLookupValues(this.lookupValue.Title),
      this.getListOfLookupValues(this.lookupValue.MaritalStatus),
      this.getListOfLookupValues(this.lookupValue.Gender),
      this.getListOfLookupValues(this.lookupValue.CoverStatus),
      this.getListOfLookupValues(this.lookupValue.DiagnosisGroup),
      this.getListOfLookupValues(this.lookupValue.RemunerationPeriod)
    ];

    return forkJoin(lookupRequests);
  }

  initSubscriptions(): void {
    this.policyNumberTextChanged$
      .pipe(
        takeUntil(this.destroyed$),
        debounceTime(this.debounceTime),
        distinctUntilChanged()
      )
      .subscribe((value: string) => {
          this.getListOfPolicies(value);
        },
        error => console.log(error));
  }

  ngAfterViewChecked(): void {
    this.changeDetect.detectChanges();
  }

  getFilteredListOfAssociatedPerson() {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblInsuredPerson;
    pagedRequestDTO.pageNumber = 0;
    pagedRequestDTO.pageSize = PAGE_SIZE;

    pagedRequestDTO.fieldMap = createFieldMap(
      'lastName',
      this.associatedPersonFormControl.value
    );
    this.insuredPersonService.getListOfAssociatedPerson(pagedRequestDTO).subscribe(
      (response) => {
        this.associatedPersonData = response.resultList as InsuredPersonDTO[];
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.handleError(error.businessMessage);
      }
    );
  }

  associatedPersonSelected(insuredPerson: InsuredPersonDTO) {
    this.associatedPersonFormControl.setValue(this.getPersonName(insuredPerson));
    this.selectedAssociatedPerson = {
      value: insuredPerson.insuredPersonId,
      name: insuredPerson.lastName
    };
  }

  getPersonName(insuredPerson: InsuredPersonDTO) {
    return `${insuredPerson.firstName} ${insuredPerson.middleName ? insuredPerson.middleName : ''} ${insuredPerson.lastName}`;
  }

  clearAssociatedPerson() {
    this.associatedPersonFormControl.reset();
    this.selectedAssociatedPerson = null;
  }

  blurLastNameChange() {
    this.heading = `${this.heading} - ${this.lastNameFormControl.value}`;
  }

  getListOfLookupValues(entity: string): Observable<any> {
    if (entity === this.lookupValue.Country ||
      entity === this.lookupValue.Language ||
      entity === this.lookupValue.Ethnicity ||
      entity === this.lookupValue.Payer ||
      entity === this.lookupValue.DiagnosisGroup ||
      entity === this.lookupValue.RemunerationPeriod) {
      return this.lookupService.getListOfLookupValuesWithCode(entity)
        .pipe(
          tap(response => this.handleLookupWithCodeResponse(entity, response))
        );
    }
    else {
      return this.lookupService.getListOfLookupValues(entity)
        .pipe(
          tap(response => this.handleLookupResponse(entity, response))
        );
    }
  }

  private handleLookupResponse(entity: string, response: any[]): void {
    if (entity === this.lookupValue.Association) {
      this.associations = response;
    }
    else if (entity === this.lookupValue.Regulator) {
      this.regulator = response;
    }
    else if (entity === this.lookupValue.AddressType) {
      this.addressTypes = response;
      this.addressType.setValue(this.addressTypes.find(type => type.value === 1));
    }
    else if (entity === this.lookupValue.EntityStatus) {
      this.entityStatus = response;
    }
    else if (entity === this.lookupValue.Designation) {
      this.designations = response;
      this.contactDesignationFormControl.setValue(this.designations.find(designation => designation.value === 5));
    }
    else if (entity === this.lookupValue.Title) {
      this.titles = response;
    }
    else if (entity === this.lookupValue.MaritalStatus) {
      this.maritalStatus = response;
    }
    else if (entity === this.lookupValue.Gender) {
      this.genders = response;
    }
    else if (entity === this.lookupValue.CoverStatus) {
      this.coverStatuses = response;
      this.statusFormControl.setValue(this.coverStatuses.find(status => status.value === 1));
    }
  }

  private handleLookupWithCodeResponse(entity: string, response: any[]): void {
    if (entity === this.lookupValue.Country) {
      this.countries = response;
      const southAfrica = this.countries.find(status => status.code === 'ZA');
      this.countryFormControl.setValue(southAfrica);
      this.nationalityFormControl.setValue(southAfrica?.name);
    }
    else if (entity === this.lookupValue.Language) {
      this.languages = response;
    }
    else if (entity === this.lookupValue.Ethnicity) {
      this.ethnicities = response;
    }
    else if (entity === this.lookupValue.Payer) {
      this.schemes = response;
    }
    else if (entity === this.lookupValue.DiagnosisGroup) {
      this.diagnosisGroups = response;
    }
    else if (entity === this.lookupValue.RemunerationPeriod) {
      this.periods = response;
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 10000
    });
  }

  addPreExistingCondition() {

  }

  getHelpInfo(componentName: string) {
    this.helpService.getListOfHelpInfo(componentName).subscribe(
      (response) => {
        this.helpInfo = response;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.handleError(error.businessMessage);
      }
    );
  }

  getInsuredPersonById(insuredPersonId: number): void {
    this.insuredPersonService.getInsuredPerson(insuredPersonId).subscribe(
      (response) => {
        this.insuredPerson = response;
        this.setFormsForEdit(response);

      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.handleError(error.businessMessage);
      }
    );
  }

  setFormsForEdit(data: InsuredPersonDTO) {
    this.bankAccounts.set(data.bankAccounts || []);

    // Set contact form inputs first, before updating form controls
    const title = this.titles.find(item => item.name === data.title?.name);
    this.titleFormControl.setValue(title?.name);

    // Update contact form inputs with initial data
    this.contactFormInputs = {
      title: data.title,
      firstName: data.firstName,
      middleName: data.middleName,
      lastName: data.lastName
    };

    const country = data.country?.name;
    const maritalStatus = data.maritalStatus?.name;
    const association = data.association?.name;
    const gender = data.gender?.name;
    const language = this.languages?.find(x => x.value == data.language.value);
    const ethnicity = this.ethnicities?.find(x => x.value == data.ethnicity.value);
    this.middleNameFormControl.setValue(data.middleName);
    this.titleFormControl.setValue(title?.name);
    this.firstNameFormControl.setValue(data.firstName);
    this.associatedPersonFormControl.setValue(null);
    this.maritalStatusFormControl.setValue(maritalStatus);
    this.passportNumberFormControl.setValue(data.passportNumber);
    this.genderFormControl.setValue(gender);
    this.nationalIdNumberFormControl.setValue(data.nationalIdNumber);
    this.lastNameFormControl.setValue(data.lastName);
    this.associationFormControl.setValue(association);
    this.alternativeCardNumberFormControl.setValue(data.alternative1CardNumber);
    this.nationalityFormControl.setValue(country);
    this.dateOfBirthFormControl.setValue(new Date(data.dateOfBirth));
    this.dateOfMarriageFormControl.setValue(new Date(data.dateOfMarriage));
    this.languageFormControl.setValue(language);
    this.ethnicityFormControl.setValue(ethnicity);
    this.associatedPersonFormControl.setValue(data.associatedInsuredPerson ? data.associatedInsuredPerson.name : null);
    this.selectedAssociatedPerson = data.associatedInsuredPerson;
    this.associatedPerson = data.associatedInsuredPerson ? 'Yes' : 'No';
    this.idNumberExistsFormControl.setValue(data.idNumberExists);

    // Temp Store backend-provided ID
    this.backendProvidedId = data.nationalIdNumber;

    if (this.associatedPerson === 'Yes') {
      this.isRequired = true;
    }
    this.updateStatus = 'No';
    this.idCopyBase64 = data.passportCopy;
    this.digitalCopyBase64 = data.photo;
    this.blurLastNameChange();
    this.onBlurFirstName();
    this.onBlurMiddleName();
    this.onBlurLastName();
    this.onBlurTitle();

    // Now trigger validation setup
    this.onIdNumberExistsChange();

    this.generalFormGroup = this.formBuilder.group({
      middleName: this.middleNameFormControl,
      title: this.titleFormControl,
      firstName: this.firstNameFormControl,
      associatedPerson: this.associatedPersonFormControl,
      maritalStatus: this.maritalStatusFormControl,
      passportNumber: this.passportNumberFormControl,
      gender: this.genderFormControl,
      nationalIdNumber: this.nationalIdNumberFormControl,
      lastName: this.lastNameFormControl,
      association: this.associationFormControl,
      alternativeCardNumber: this.alternativeCardNumberFormControl,
      nationality: this.nationalityFormControl,
      dateOfBirth: this.dateOfBirthFormControl !== null ? this.dateOfBirthFormControl : null,
      dateOfMarriage: this.dateOfMarriageFormControl,
      language: this.languageFormControl,
      ethnicity: this.ethnicityFormControl,
      idNumberExists: this.idNumberExistsFormControl,
    });
    if (data.coverStatuses && data.coverStatuses.length) {
      this.selectedCoverStatuses = data.coverStatuses.map(element => {
        element.updated = new Date();
        element.updatedBy = this.userFirstLastName;
        element.created = new Date();
        element.createdBy = this.userFirstLastName;
        element.coverStatus.updated = new Date();
        element.coverStatus.updatedBy = this.userFirstLastName;
        element.coverStatus.created = new Date();
        element.coverStatus.createdBy = this.userFirstLastName;
        return element;
      });
      // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
      this.selectedCoverStatuses.sort(function(a, b) {
        return new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
      });
      if (this.selectedCoverStatuses.length > 1) {
        for (let i = 0; i < this.selectedCoverStatuses.length - 1; i++) {
          this.selectedCoverStatuses[i + 1].endDate =
            new Date(new Date(this.selectedCoverStatuses[i].startDate).setDate(new Date(this.selectedCoverStatuses[i].startDate).getDate() - 1));
        }
        this.minDate = new Date(new Date(this.selectedCoverStatuses[0].startDate)
          .setDate(new Date(this.selectedCoverStatuses[0].startDate).getDate() + 1));
      }
    }
    else {
      this.selectedCoverStatuses = [];
    }
    this.statusFormGroup = this.formBuilder.group({
        status: this.statusFormControl,
        statusStartDate: this.statusStartDateFormControl,
        policy: this.policyFormControl,
        product: this.productFormControl
      }, {validators: [minimumCoveredStatus(this.selectedCoverStatuses)]} // ,minimumPreExistingCondition(this.selectedPreExistingCondition)] }
    );
    if (data.contacts?.length) {
      const coverageHistoryList = this.insuredPerson.coverageHistory;
      if (coverageHistoryList && coverageHistoryList.length > 0) {
        this.previousMedicalAid = 'Yes';
        const latestCoverage = coverageHistoryList
          .filter(item => item?.startDate) // Ensure items have a startDate
          .sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime())[0];
        const association = this.associations.find(x => x.value == latestCoverage.association?.value);
        const payer = this.schemes.find(x => x.value == latestCoverage.payer?.value);
        this.schemeFormControl.setValue(payer);
        this.coverageAssociationFormControl.setValue(association);
        this.coverageMembershipNumberFormControl.setValue(latestCoverage.membershipNumber);
        this.coverageStartDateFormControl.setValue(new Date(latestCoverage.startDate));
        this.coverageEndDateFormControl.setValue(latestCoverage.endDate ? new Date(latestCoverage.endDate) : null);
      }

      if (this.insuredPerson.insuredPersonExclusions) {
        this.selectedConditionExclusions = this.insuredPerson.insuredPersonExclusions;
      }

      this.medicalHistoryFormGroup = this.formBuilder.group({
        condition: this.conditionFormControl,
        conditionStartDate: this.conditionStartDateFormControl,
        conditionEndDate: this.conditionEndDateFormControl,
        scheme: this.schemeFormControl,
        association: this.coverageAssociationFormControl,
        membershipNumber: this.coverageMembershipNumberFormControl,
        coverageStartDate: this.coverageStartDateFormControl,
        coverageEndDate: this.coverageEndDateFormControl
      });

      const remunerationList = this.insuredPerson.remunerationList;
      if (remunerationList && remunerationList.length > 0) {
        this.remunerationHistory = 'Yes';
        const latestRemuneration = remunerationList
          .filter(item => item?.startDate) // Ensure items have a startDate
          .sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime())[0];
        const remunerationPeriod = this.periods.find(x => x.value == latestRemuneration.period?.value);
        this.remunerationAmountFormControl.setValue(latestRemuneration.amount);
        this.remunerationPeriodFormControl.setValue(remunerationPeriod);
        this.remunerationStartDateFormControl.setValue(new Date(latestRemuneration.startDate));
        this.remunerationEndDateFormControl.setValue(latestRemuneration.endDate ? new Date(latestRemuneration.endDate) : null);
      }

      this.taxNumberFormControl.setValue(this.insuredPerson.taxNumber);
      this.financialFormGroup = this.formBuilder.group({
          amount: this.remunerationAmountFormControl,
          period: this.remunerationPeriodFormControl,
          remunerationStartDate: this.remunerationStartDateFormControl,
          remunerationEndDate: this.remunerationEndDateFormControl,
          taxNumber: this.taxNumberFormControl
        }
      );

    }
  }

  onBlurFirstName() {
    this.contactFormInputs = {
      ...this.contactFormInputs,
      firstName: this.firstNameFormControl.value
    };
  }

  onBlurMiddleName() {
    this.contactFormInputs = {
      ...this.contactFormInputs,
      middleName: this.middleNameFormControl.value
    };
  }

  onBlurLastName() {
    this.contactFormInputs = {
      ...this.contactFormInputs,
      lastName: this.lastNameFormControl.value
    };
  }

  onBlurTitle() {
    const title = this.titles.find(item => item.name === this.titleFormControl.value);
    this.contactFormInputs = {
      ...this.contactFormInputs,
      title
    };
  }

  idNumberChange() {
    this.updateIdValidationMessage();
  }

  updateIdValidationMessage() {

    if (this.nationalIdNumberFormControl.invalid && this.nationalIdNumberFormControl.errors) {
      const firstErrorKey = Object.keys(this.nationalIdNumberFormControl.errors)[0];
      this.idErrorMessage = this.idErrorMessagesList[firstErrorKey] || null;
    }
    else {
      this.idErrorMessage = null;
    }
  }

  addCondition() {
    const conditionNameValueCodeDTO = this.conditionFormControl.value;
    if (!conditionNameValueCodeDTO || !this.conditionStartDateFormControl.value) {
      this.preExistingConditionError = true;
      return;
    }
    else {
      this.preExistingConditionError = false;
    }
    const conditionExclusion = new InsuredPersonExclusionDTO();
    conditionExclusion.insuredPersonId = this.insuredPerson ? this.insuredPerson.insuredPersonId : null;
    conditionExclusion.diagnosisGroup = new DiagnosisGroupDTO(conditionNameValueCodeDTO.value, conditionNameValueCodeDTO.code, conditionNameValueCodeDTO.name);
    conditionExclusion.startDate = this.conditionStartDateFormControl.value;
    conditionExclusion.endDate = this.conditionEndDateFormControl.value;
    this.selectedConditionExclusions.push(conditionExclusion);
    this.conditionFormControl.reset();
    this.conditionStartDateFormControl.reset();
    this.conditionEndDateFormControl.reset();
  }

  async selectedStatus() {
    if (this.statusFormControl.value && this.statusStartDateFormControl.value) {
      this.statusRequiredFieldsSelected = true;
      this.selectedCoverStatuses.push(this.addCoverStatusToSelectedList());
      // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
      this.selectedCoverStatuses = this.selectedCoverStatuses.sort(function(a, b) {
        return new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
      });
      if (this.selectedCoverStatuses.length > 1) {
        for (let i = 0; i < this.selectedCoverStatuses.length - 1; i++) {
          this.selectedCoverStatuses[i + 1].endDate =
            new Date(new Date(this.selectedCoverStatuses[i].startDate)
              .setDate(new Date(this.selectedCoverStatuses[i].startDate).getDate() - 1));
        }
      }
      this.statusFormGroup.reset();
    }
    else {
      this.statusRequiredFieldsSelected = false;
      this.statusErrorMessage = this.statusErrorMessagesList.statusMandatoryError;
    }
  }

  private addCoverStatusToSelectedList(): CoverStatusLinkDTO {
    const coverStatus: CoverStatusDTO = {
      coverStatusId: this.statusFormControl.value.value,
      created: null,
      createdBy: null,
      name: this.statusFormControl.value.name,
      tenantId: null,
      updated: null,
      updatedBy: null
    };
    const status: CoverStatusLinkDTO = {
      coverStatus,
      created: new Date(),
      createdBy: this.userFirstLastName,
      endDate: null,
      startDate: this.statusStartDateFormControl.value,
      tenantId: null,
      updated: null,
      updatedBy: null
    };

    return status;
  }

  onRadioBtnChange() {
    if (this.associatedPerson === 'No') {
      this.associatedPersonFormControl.setValue(null);
      this.isRequired = false;
      this.associatedPersonFormControl.clearValidators();
      this.associatedPersonFormControl.updateValueAndValidity();
      this.selectedAssociatedPerson = null;
    }
    else {
      this.isRequired = true;
    }
  }

  resetGeneralFormGroup() {
    this.generalFormGroup.reset();
  }


  resetStatusFormGroup() {
    this.statusFormGroup.reset();
  }

  resetStatutoryFormGroup() {
    this.financialFormGroup.reset();
  }


  resetMedicalHistoryFormGroup() {
    this.medicalHistoryFormGroup.reset();
  }


  onInputChangedSearchAssociatedPerson($event) {
    this.associatedPersonTextChanged.next($event.target.value);
  }

  getAddressDisplayString(address) {
    return `${address?.type?.name} - ${address?.addressLineOne} - ${address?.cityTown} - ${address?.province} -
    ${address?.country?.name} - ${address?.postalCode}`;
  }

  getContactDisplayString(contact) {
    return `${contact?.designation?.name} - ${contact?.title?.name} ${contact?.firstName} ${contact?.middleName ? contact.middleName : ''} ${contact?.lastName} -
    ${contact?.emailAddress} - Mobile: ${contact?.mobileNumber} - Landline: ${contact?.telephoneNumber}`;
  }

  getConditionDisplayString(condition: InsuredPersonExclusionDTO) {
    return `${condition?.diagnosisGroup ? condition?.diagnosisGroup?.name : condition?.diagnosis?.code}: ${this.dateFormat(condition?.startDate)} - ${condition?.endDate ? this.dateFormat(condition?.endDate) : ''}`;
  }

  handleInputChangeForDigitalCopy(e) {

    const fileList: FileList = e.target.files;

    const file: File = fileList[0];
    if (file.size > 5000000) {
      return;
    }
    this.getBase64ForDigitalCopy(e);
  }

  handleInputChangeForId(e) {

    const fileList: FileList = e.target.files;

    const file: File = fileList[0];
    if (file.size > 5000000) {
      return;
    }
    this.getBase64ForId(e);
  }

  getBase64ForDigitalCopy(event) {
    const me = this;
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      me.digitalCopyBase64 = reader.result;
    };
  }

  getBase64ForId(event) {
    const me = this;
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      me.idCopyBase64 = reader.result;
    };
  }

  removeCondition(condition: InsuredPersonExclusionDTO) {
    const index = this.selectedConditionExclusions.indexOf(condition, 0);
    if (index > -1) {
      this.selectedConditionExclusions.splice(index, 1);
    }
  }

  getInfoTooltip(inputName: string): string {
    let message = '';
    if (this.helpInfo) {
      const helpInfo = this.helpInfo.find((help) => help.inputName === inputName);
      message = helpInfo ? helpInfo.inputInfo : '';
    }
    return message;
  }

  openBankAccountDialog(): void {
    const tempPerson = new InsuredPersonDTO();
    tempPerson.bankAccounts = this.bankAccounts();
    tempPerson.lastName = this.lastNameFormControl.value || '';

    const dialogRef = this.dialog.open(AddBankAccountDialogComponent, {
      width: '40vw',
      height: '80vh',
      data: {insuredPerson: tempPerson, entityType: 'Insured Person'}
    });

    dialogRef.afterClosed().subscribe((result: BankAccountLinkDTO[]) => {
      if (result) {
        this.bankAccounts.set(result);
      }
    });
  }

  handleError(errorMessage: string) {
    this.dialog.open(ErrorDialogComponent, {
      width: '40vw',
      data: errorMessage
    });
  }

  getCoveredStatusDisplayString(coveredStatus) {
    return `${coveredStatus.coverStatus.name}:  ${this.dateFormat(coveredStatus.startDate)} - ${coveredStatus.endDate ? this.dateFormat(coveredStatus.endDate) : ''}`;
  }

  dateFormat(date) {
    return this.datePipe.transform(new Date(date), this.dateFormatString);
  }
  submitInsuredPerson() {
    const insuredPerson = this.getInuredPersonPayload();
    this.disableActivityPage();
    const isAddedDependent = this.addToMembership == 'Yes';
    this.insuredPersonService.addInsuredPerson(insuredPerson, isAddedDependent)
      .pipe(
        finalize(() => {
          this.enableActivityPage();
        }),
        takeUntil(this.destroyed$)
      )
      .subscribe({
        next: (response) => {
          this.returnMessage = response;
          this.openSnackBar(`${insuredPerson.firstName} ${insuredPerson.lastName} saved successfully`, 'Dismiss');
          const route = this.getBackPageRoute();
          this.router.navigate([route.path], {queryParams: route.queryParams});
        },
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.handleError(error.businessMessage);
        }
      });
  }
  getBackPageRoute(): { path: string, queryParams: any } {
    const routes = {
      [PortalType.Normal]: {path: '/enterprise-management', queryParams: {tab: EnterpriseRoutesQueryParam.Person}},
      [PortalType.OnBoarding]: {path: '/onboarding/persons', queryParams: {}},
      [PortalType.Broker]: {path: '/broker/persons', queryParams: {}}
    };
    return routes[this.currentPortal];
  }

  getInuredPersonPayload() {
    const title = this.titles.find(item => item.name === this.titleFormControl.value);
    const country = this.countries.find(item => item.name === this.nationalityFormControl.value);
    const maritalStatus = this.maritalStatus.find(item => item.name === this.maritalStatusFormControl.value);
    const association = this.associations.find(item => item.name === this.associationFormControl.value);
    const gender = this.genders.find(item => item.name === this.genderFormControl.value);

    const coverageHistoryList: CoverageHistoryDTO[] = [];
    if (this.previousMedicalAid == 'Yes') {
      const coverageHistory = new CoverageHistoryDTO();
      coverageHistory.payer = this.schemeFormControl.value;
      coverageHistory.association = this.coverageAssociationFormControl.value;
      coverageHistory.membershipNumber = this.coverageMembershipNumberFormControl.value;
      coverageHistory.startDate = this.coverageStartDateFormControl ? new Date(this.coverageStartDateFormControl.value) : null;
      coverageHistory.endDate = this.coverageEndDateFormControl ? new Date(this.coverageEndDateFormControl.value) : null;
      coverageHistoryList.push(coverageHistory);
    }

    const remunerationList: RemunerationDTO[] = [];
    if (this.remunerationHistory == 'Yes') {
      const remuneration = new RemunerationDTO();
      remuneration.amount = this.remunerationAmountFormControl.value;
      remuneration.period = this.remunerationPeriodFormControl.value;
      remuneration.startDate = this.remunerationStartDateFormControl ? new Date(this.remunerationStartDateFormControl.value) : null;
      remuneration.endDate = this.remunerationEndDateFormControl ? new Date(this.remunerationEndDateFormControl.value) : null;
      remunerationList.push(remuneration);
    }

    const addressPayload = this.addressFormComponent.getPayload();
    const contactPayload = this.contactFormComponent.getPayload();

    if (this.isEdit) {

      const currentIdNumber = this.nationalIdNumberFormControl.value;
      const isIdNumberExists = this.idNumberExistsFormControl.value;

      const payload: InsuredPersonDTO = {
        addresses: addressPayload?.addresses || [],
        contacts: contactPayload?.contacts || [],
        alternative1CardNumber: this.alternativeCardNumberFormControl.value,
        alternative2CardNumber: null,
        association,
        bankAccounts: this.bankAccounts(),
        cardNumber: this.insuredPerson.cardNumber,
        country,
        coverStatuses: this.selectedCoverStatuses,
        created: new Date(),
        createdBy: this.userFirstLastName,
        dateOfBirth: new Date(this.dateOfBirthFormControl.value),
        firstName: this.firstNameFormControl.value,
        gender,
        designation: null,
        insuredPersonId: this.insuredPerson.insuredPersonId,
        lastName: this.lastNameFormControl.value,
        maritalStatus,
        middleName: this.middleNameFormControl.value,
        nationalIdNumber: isIdNumberExists ? currentIdNumber : this.backendProvidedId,
        passportCopy: null, // TODO Fix in GU-512 this.idCopyBase64 ? this.idCopyBase64.split('base64,')[1] : null,
        passportNumber: this.passportNumberFormControl.value,
        photo: null, // TODO Fix in GU-512 this.digitalCopyBase64 ? this.digitalCopyBase64.split('base64,')[1] : null,
        sanctionCheckDate: this.insuredPerson.sanctionCheckDate,
        sanctionIndicator: this.insuredPerson.sanctionIndicator,
        sanctionReference: null,
        tenantId: null,
        title,
        associatedInsuredPerson: this.selectedAssociatedPerson,
        underDiseaseManagementIndicator: this.selectedConditionExclusions?.length > 0 ? 1 : 0,
        updated: new Date(),
        updatedBy: this.userFirstLastName,
        vipIndicator: 0,
        insuredPersonExclusions: this.selectedConditionExclusions,
        insuredPersonCardHistories: this.insuredPerson.insuredPersonCardHistories,
        status: null, startDate: null, endDate: null, policyNumber: null,
        dependentNumber: '',
        taxNumber: this.taxNumberFormControl.value,
        dateOfMarriage: new Date(this.dateOfMarriageFormControl.value),
        language: this.languageFormControl.value,
        ethnicity: this.ethnicityFormControl.value,
        policyProductPersonLinks: this.insuredPerson.policyProductPersonLinks,
        remunerationList,
        coverageHistory: coverageHistoryList,
        idNumberExists: isIdNumberExists,
        policyProductVariances: null,
        policyProductWaivers: null
      };
      return payload;
    }
    else {
      const coverStatuses = [];
      coverStatuses.push(this.addCoverStatusToSelectedList());

      const policyProductPersonLinks: PersonPolicyProductLinkDTO[] = [];
      if (this.addToMembership == 'Yes') {
        const policyProductPersonLink: PersonPolicyProductLinkDTO = new PersonPolicyProductLinkDTO();
        policyProductPersonLink.policy = this.selectedPolicy;
        policyProductPersonLink.product = CreateNameValueCodeDTO(this.selectedProduct.productId, this.selectedProduct.name, this.selectedProduct.productCode);
        policyProductPersonLink.startDate = new Date(this.statusStartDateFormControl.value);
        policyProductPersonLinks.push(policyProductPersonLink);
      }

      const payload: InsuredPersonDTO = {
        addresses: addressPayload?.addresses || [],
        contacts: contactPayload?.contacts || [],
        alternative1CardNumber: null,
        alternative2CardNumber: null,
        association,
        bankAccounts: this.bankAccounts().length > 0 ? this.bankAccounts() : null,
        cardNumber: this.selectedPolicy ? this.selectedPolicy.number + String(association.value) : null,
        country,
        coverStatuses,
        created: new Date(),
        createdBy: this.userFirstLastName,
        dateOfBirth: new Date(this.dateOfBirthFormControl.value),
        firstName: this.firstNameFormControl.value,
        gender,
        designation: null,
        insuredPersonId: null,
        lastName: this.lastNameFormControl.value,
        maritalStatus,
        middleName: this.middleNameFormControl.value,
        nationalIdNumber: this.nationalIdNumberFormControl.value,
        passportCopy: this.idCopyBase64 ? this.idCopyBase64.split('base64,')[1] : null,
        passportNumber: this.passportNumberFormControl.value,
        photo: this.digitalCopyBase64 ? this.digitalCopyBase64.split('base64,')[1] : null,
        associatedInsuredPerson: this.selectedAssociatedPerson,
        sanctionCheckDate: null,
        sanctionIndicator: null,
        sanctionReference: null,
        tenantId: null,
        title,
        underDiseaseManagementIndicator: this.selectedConditionExclusions?.length > 0 ? 1 : 0,
        updated: null,
        updatedBy: null,
        vipIndicator: 0,
        insuredPersonExclusions: this.selectedConditionExclusions,
        insuredPersonCardHistories: null,
        status: null, startDate: null, endDate: null, policyNumber: null,
        dependentNumber: '',
        taxNumber: this.taxNumberFormControl.value,
        dateOfMarriage: new Date(this.dateOfMarriageFormControl.value),
        language: this.languageFormControl.value,
        ethnicity: this.ethnicityFormControl.value,
        policyProductPersonLinks,
        remunerationList,
        coverageHistory: coverageHistoryList,
        idNumberExists: this.idNumberExistsFormControl.value,
        policyProductVariances: null,
        policyProductWaivers: null
      };
      return payload;
    }
  }

  private disableActivityPage() {
    this.financialFormGroup.disable();
    this.activityBackButton.disabled = true;
    this.activityClearButton.disabled = true;
    this.finishButton.disabled = true;
    this.generalStep.editable = false;
    this.addressStep.editable = false;
    this.contactsStep.editable = false;
    this.statutoryStep.editable = false;
    this.statusStep.editable = false;
  }

  private enableActivityPage() {
    this.financialFormGroup.enable();
    this.activityBackButton.disabled = false;
    this.activityClearButton.disabled = false;
    this.finishButton.disabled = false;
    this.generalStep.editable = true;
    this.addressStep.editable = true;
    this.contactsStep.editable = true;
    this.statutoryStep.editable = true;
    this.statusStep.editable = true;
  }

  disableFinishButton(): boolean {
    let isDisabled = false;
    if (!this.financialFormGroup.valid) {
      isDisabled = true; // Disable if form invalid
    }
    if (this.createdBySystem()
      && !this.userRoles.find(role => role === Role.GreydomAdmin)) {
      isDisabled = true; // Disable if created or updated by system, except for administrators
    }
    if (this.isEdit && this.addToMembership == 'Yes') {
      isDisabled = true; // Disable if onboarding
    }
    return isDisabled;
  }

  createdBySystem(): boolean {
    const SYSTEM = 'system';
    const createdBy = this.insuredPerson?.createdBy?.toLowerCase();
    const updatedBy = this.insuredPerson?.updatedBy?.toLowerCase();
    return this.insuredPerson && (createdBy === SYSTEM || updatedBy === SYSTEM);
  }

  disableTooltip(): string {
    if (this.createdBySystem()) {
      return DisplayStrings.generic.externalSystem;
    }
    return '';
  }

  private getListOfPolicies(value: string): void {
    let pagedRequestDTO: PagedRequestDTO;

    pagedRequestDTO = ClmRequestBuilder.getFilteredListOfPoliciesPagedRequestDTO(value);

    this.policyService.getListOfPolicies(pagedRequestDTO)
      .pipe(
        take(1),
      )
      .subscribe(
        (response: PagedResponseDTO<PolicyDTO>) => {
          response.resultList = response.resultList.map((policy: PolicyDTO) => {
            return policy;
          });
          this.filteredPolicies = response.resultList;
        },
        (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error.businessMessage);
        }
      );
  }

  onBlurPolicyNumber() {
    const value = this.policyFormControl.value;
    const isMatched = this.filteredPolicies?.find(
      (item: PolicyDTO) => value === this.getPolicyDisplayString(item)
    ) !== undefined;

    if (!isMatched) {
      this.clearPolicy();
    }
  }

  onPolicySelected(name: string) {
    this.selectedPolicy = this.filteredPolicies?.find(
      (item: PolicyDTO) => name === this.getPolicyDisplayString(item)
    );
    this.loadProducts();
  }

  clearPolicy() {
    this.policyFormControl.reset();
    this.selectedPolicy = null;
    // this.filteredPolicies = [];
    this.clearProduct();
  }

  getPolicyDisplayString(policy: PolicyDTO): string {
    return `${policy.name} - ${policy.number}`;
  }

  onProductSelected(id: number) {
    if (this.products) {
      this.selectedProduct = this.products.find((item: ProductDTO) => id === item.productId);
    }
  }

  clearProduct() {
    this.productFormControl.reset();
    this.selectedProduct = null;
    // this.products = [];
  }

  getProductDisplayName(product: ProductDTO) {
    return `${product.productCode}: ${product.name} (${product.productStartDateForPerson} -
        ${product.productEndDateForPerson !== null ? product.productEndDateForPerson : ''})`;
  }

  loadProducts() {
    if (!this.selectedPolicy) {
      return;
    }
    this.productService.getPolicyLinkedProducts(this.selectedPolicy.policyId)
      .pipe(
        take(1),
      )
      .subscribe(
        (response: ProductDTO[]) => {
          this.products = response;
        },
        (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error.businessMessage);
        }
      );
  }

  onRemunerationChange() {
    if (this.addToMembership == 'Yes') {
      // Policy
      this.policyFormControl.setValidators([Validators.required]);
      this.policyFormControl.updateValueAndValidity();
      // Product
      this.productFormControl.setValidators([Validators.required]);
      this.productFormControl.updateValueAndValidity();
    }
    else {
      // Policy
      this.policyFormControl.clearAsyncValidators();
      this.policyFormControl.setValidators(null);
      this.policyFormControl.updateValueAndValidity();
      this.clearPolicy();
      // Product
      this.productFormControl.clearAsyncValidators();
      this.productFormControl.setValidators(null);
      this.productFormControl.updateValueAndValidity();
      this.clearProduct();
    }

    if (this.previousMedicalAid == 'Yes') {
      // Scheme
      this.schemeFormControl.setValidators([Validators.required]);
      this.schemeFormControl.updateValueAndValidity();
      // Start Date
      this.coverageStartDateFormControl.setValidators([Validators.required]);
      this.coverageStartDateFormControl.updateValueAndValidity();
      // End Date
      this.coverageEndDateFormControl.setValidators([Validators.required]);
      this.coverageEndDateFormControl.updateValueAndValidity();
    }
    else {
      // Scheme
      this.schemeFormControl.clearAsyncValidators();
      this.schemeFormControl.setValidators(null);
      this.schemeFormControl.updateValueAndValidity();
      this.schemeFormControl.reset();
      // Association
      this.coverageAssociationFormControl.reset();
      // Membership Number
      this.coverageMembershipNumberFormControl.reset();
      // Start Date
      this.coverageStartDateFormControl.clearAsyncValidators();
      this.coverageStartDateFormControl.setValidators(null);
      this.coverageStartDateFormControl.updateValueAndValidity();
      this.coverageStartDateFormControl.reset();
      // End Date
      this.coverageEndDateFormControl.clearAsyncValidators();
      this.coverageEndDateFormControl.setValidators(null);
      this.coverageEndDateFormControl.updateValueAndValidity();
      this.coverageStartDateFormControl.reset();
    }

    if (this.remunerationHistory == 'Yes') {
      // Remuneration Amount
      this.remunerationAmountFormControl.setValidators([Validators.required]);
      this.remunerationAmountFormControl.updateValueAndValidity();
      // Remuneration Period
      this.remunerationPeriodFormControl.setValidators([Validators.required]);
      this.remunerationPeriodFormControl.updateValueAndValidity();
      // End Date
      this.remunerationStartDateFormControl.setValidators([Validators.required]);
      this.remunerationStartDateFormControl.updateValueAndValidity();
    }
    else {
      // Remuneration Amount
      this.remunerationAmountFormControl.clearAsyncValidators();
      this.remunerationAmountFormControl.setValidators(null);
      this.remunerationAmountFormControl.updateValueAndValidity();
      this.remunerationAmountFormControl.reset();
      // Remuneration Amount
      this.remunerationPeriodFormControl.clearAsyncValidators();
      this.remunerationPeriodFormControl.setValidators(null);
      this.remunerationPeriodFormControl.updateValueAndValidity();
      this.remunerationPeriodFormControl.reset();
      // Start Date
      this.remunerationStartDateFormControl.clearAsyncValidators();
      this.remunerationStartDateFormControl.setValidators(null);
      this.remunerationStartDateFormControl.updateValueAndValidity();
      // Start Date
      this.remunerationEndDateFormControl.reset();
    }
  }

  onIdNumberExistsChange(): void {
    const hasIdNumber = this.idNumberExistsFormControl.value;
    const isEditing = !!this.insuredPersonId;

    this.handleIdValidation(hasIdNumber, isEditing);
    this.handlePassportValidation(hasIdNumber);
  }

  private handleIdValidation(hasIdNumber: boolean, isEditing: boolean): void {
    if (hasIdNumber) {
      // Always apply full validation when enabled
      this.nationalIdNumberFormControl.enable();
      this.nationalIdNumberFormControl.setValidators(this.ID_NUMBER_VALIDATORS);
    }
    else {
      // When toggle is OFF, restore backend value or clear
      const valueToRestore = isEditing ? this.backendProvidedId : null;
      this.nationalIdNumberFormControl.setValue(valueToRestore);
      this.nationalIdNumberFormControl.clearValidators();
      this.nationalIdNumberFormControl.disable();
    }

    this.nationalIdNumberFormControl.updateValueAndValidity();
  }

  private handlePassportValidation(hasIdNumber: boolean): void {
    this.passportNumberFormControl.setValidators(!hasIdNumber ? [Validators.required] : []);
    this.passportNumberFormControl.updateValueAndValidity();
  }

  private getCustomRoute(): string {
    const routes = {
      [PortalType.Normal]: null,
      [PortalType.OnBoarding]: '/onboarding/persons',
      [PortalType.Broker]: '/broker/persons',
    };
    return routes[this.currentPortal] || null;
  }
}
